module.exports = __webpack_public_path__ + "img/autotagging_3.92c8ac01.jpg";